<template>
  <div>
    <v-card-title class="px-0">

      <v-card-text v-if="updateInfo && showLoadingUploadContacts">
        <div class="text-lg-right"><v-btn flat small @click="showLoadingUploadContacts = false">Close</v-btn></div>
        <h5 v-if="updateInfo.status === 'dispath'">Wait while the data is processed and the loading time is estimated</h5>
        <h5 v-if="updateInfo.status === 'processing'">Uploading data</h5>
        <h5 v-if="updateInfo.status === 'ready'">Uploaded successfully</h5> 
        <v-progress-linear
          :color="barColor"
          height="20"
          :value="processLoading"
        > </v-progress-linear>
        <p class="text-md-center"><strong class="text-md-center" v-if="updateInfo.status !== 'dispath'"> {{ updateInfo.processed}} / {{updateInfo.total }} </strong></p>
        <v-alert
          :value="true"
          color="success"
          icon="check_circle"
          outline
        >
        <ul class="ml-2">
          <li>
            Total: {{updateInfo.total}}
          </li>
          <li>
            Processed: {{updateInfo.processed}}
          </li>
          <li>
            Inserts: {{updateInfo.inserts}}
          </li>
          <li>
            Update: {{updateInfo.updates}}
          </li>

        </ul>
        </v-alert>

      </v-card-text>

      <v-text-field
        v-model="search"
        type="search"
        append-icon="search"
        label="Search"
        single-line hide-details
      ></v-text-field>

      <v-spacer></v-spacer>

      <v-btn @click="showModalUpload = true">
        <v-icon dark>mdi-wrench</v-icon>
          Import Contacts
        <v-icon class="ml-2">contacts</v-icon>
      </v-btn>
    </v-card-title>
    <v-spacer></v-spacer>
    <v-data-table
      :headers="headers"
      :items="contacts"
      class="elevation-1"
      item-key="id"
      v-model="selected"
      :pagination.sync="itemsPerPageOptions"
      :rows-per-page-items="rowsPerPageSelect"
      :total-items="totalContacts"
    >
    <!--
    <v-data-table
      :headers="headers"
      :items="contacts"
      :search="textSearch"
      :pagination.sync="itemsPerPageOptions"
      :total-items="0"
      :loading="loadContacts"
      :rows-per-page-items="rowsPerPageSelect"
    >
    -->
    
      <template slot="items" slot-scope="props">
        <td>
          <div class="d-flex align-center">
            <v-checkbox
              v-model="props.selected"
              primary
              hide-details
              @input="associateContact(props)"
            ></v-checkbox>
          </div>
        </td>
        <td>
          <v-tooltip top>
            <v-btn slot="activator" icon>
              <v-icon :color="statusColor(props.item.status)" size="16">{{ emailStatusIcon(props.item.status) }}</v-icon>
            </v-btn>
            <span>{{messageOfStatus(props.item.status)}}</span>
          </v-tooltip>
        </td>
        <td>
          <v-tooltip top v-if="props.item.is_filled">
            <v-btn slot="activator" icon>
              <v-icon color="green" size="16">how_to_reg</v-icon>
            </v-btn>
            <span>The information of this contact is complete.</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <v-btn slot="activator" icon @click="editContact(props.item)">
              <v-icon color="red" size="16">how_to_reg</v-icon>
            </v-btn>
            <span>Incomplete information.</span>
          </v-tooltip>
          
        </td>
        <td> {{ props.item.name }} </td>
        <td> {{ props.item.email }} </td>
        <td> {{ props.item.position }} </td>
        <td> {{ props.item.seniority }} </td>
        <td> {{ props.item.priority }} </td>
        <td> {{ props.item.company }} </td>
        <td> {{ props.item.country }} </td>
        <td> {{ props.item.segmentation }} </td>
        <td> {{ props.item.segmentation2 }} </td>
        <td> {{ props.item.tag }} </td>
        <td class="justify-center layout px-0">
          <v-btn fab flat small color="primary mr-1" @click="editContact(props.item)">
            <v-icon small>edit</v-icon>
          </v-btn>
          <!--
          <v-btn fab flat small color="red" @click="openModalDelete(props.item)">
            <v-icon small >delete</v-icon>
          </v-btn>
          -->
        </td>
      </template>
    </v-data-table>

    <modal-upload-excel
      :showModal="showModalUpload"
      :roundId="round ? round.id : null"
      @close-modal-upload-contacts="resetShowModals"
      @show-loading-upload="setBarLoading"
    > </modal-upload-excel>

    <modal-edit-contact
      v-if="showModalEditContact"
      :showModal="showModalEditContact"
      @close-modal-edit-contact="resetShowModals"
      :contactId="selectedContact.id"
      @update-contact="loadData"
    > </modal-edit-contact>
      <!--
     <modal-delete-contact
      v-if="showModalDeleteContact"
      :showModal="showModalDeleteContact"
      @close-modal-delete-contact="resetShowModals"
      @delete-contact="loadData"
      :contact="selectedContact"
    > </modal-delete-contact>
    -->
  </div>
</template>

<script>
import ModalUploadExcel from '@/components/client/contacts/components/modals/UploadExcel.vue';
import ModalEditContact from '@/components/client/contacts/components/modals/EditContact.vue';
import ModalDeleteContact from '@/components/client/contacts/components/modals/DeleteContact.vue';

export default {
  components: {
    ModalUploadExcel,
    ModalEditContact,
    ModalDeleteContact
  },
  
  props: {
    round: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      search: '',
      showModalUpload: false,
      showModalEditContact: false,
      showModalDeleteContact: false,
      selectedContact: null,
      totalContacts: 0,
      headers: [
        { text: null, value: null, sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: null, value: 'is_filled', sortable: false },
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Segmentation 1', value: 'position', sortable: false },
        { text: 'Segmentation 2', value: 'seniority', sortable: false },
        { text: 'Segmentation 3', value: 'priority', sortable: false },
        { text: 'Segmentation 4', value: 'company', sortable: false },
        { text: 'Segmentation 5', value: 'country', sortable: false },
        { text: 'Segmentation 6', value: 'segmentation', sortable: false },
        { text: 'Segmentation 7', value: 'segmentation2', sortable: false },
        { text: 'Segmentation 8', value: 'tag', sortable: false },
        { text: 'Actions', value: null, sortable: false },
      ],
      itemsPerPageOptions: {
        descending: false,
        page: 1,
        rowsPerPage: 5,
        sortBy: ''
      },
      contacts: [],
      rowsPerPageSelect: [5, 10, 25],
      checkInterval: null,
      updateInfo: null,
      showLoadingUploadContacts: false,
      selected: [],
      countContacts: 0
    };
  },
  computed: {
    barColor: function () {
      if (this.processLoading === 100) {
        return 'success';
      }
      return 'info';
    },
    processLoading: function () {
      return (this.updateInfo.processed / this.updateInfo.total) * 100;
    },
  },
  watch: {
    itemsPerPageOptions () {
      this.loadData();
    },
    search (newValue, oldValue) {
      if (this.itemsPerPageOptions.page > 1) {
        this.itemsPerPageOptions.page = 1;
        return;
      }
      if (newValue.length > 4 || newValue === '') {
        this.loadData();
      }
    },
  },
  methods: {
    setBarLoading () {
      this.checkInterval = setInterval(this.checkUploadByReference, 3000);
    },
    checkUploadByReference () {
      let reference = localStorage.getItem('reference');
      let url = 'contacts/get-upload/' + reference;
      window.axios.get(url).then(response => {
        this.showLoadingUploadContacts = true;
        this.updateInfo = response.data.data;
        if (response.data.data.total === response.data.data.processed && response.data.data.status !== 'dispath') {
          localStorage.removeItem('reference');
          window.clearTimeout(this.checkInterval);
          this.loadData();
        }
      });
      
    },
    loadData () {
      const url = `rounds/${this.round.id}/contacts`;
      let params = {
        page: this.itemsPerPageOptions.page,
        rows_per_page: this.itemsPerPageOptions.rowsPerPage,
        sort_by: this.itemsPerPageOptions.sortBy
      };
      if (this.search !== '') {
        params.search = this.search;
      }
      params.orientation = this.itemsPerPageOptions.descending ? 'ASC' : 'DESC';

      window.axios.get(url, { params }).then(response => {
        this.contacts = response.data.data;
        this.selected = response.data.data;
        this.totalContacts = response.data.meta.total;
        
        if (this.search === '') {
          this.countContacts = response.data.meta.total;
          this.$emit('update-total-contacts', this.totalContacts);
        }
        
      });
    },
    associateContact (value) {
      let url = `rounds/${this.round.id}/associate-contact`;
      const payload = {
        contact_id: value.item.id,
        selected: value.selected ? true : false
      };
      window.axios.put(url, payload).then(response => {
        this.$emit('update-total-contacts', payload.selected ? this.countContacts : this.countContacts - 1);
      });
    },
    editContact (contact) {
      this.showModalEditContact = true;
      this.selectedContact = contact;
    },
    resetShowModals () {
      this.showModalEditContact = false;
      this.showModalDeleteContact = false;
      this.showModalUpload = false;
      this.selectedContact = null;
    },
    openModalDelete (contact) {
      this.showModalDeleteContact = true;
      this.selectedContact = contact;
    },
    messageOfStatus (status) {
      if (status === 'response') {
        return 'Survey answered';
      }
      if (status === 'delivered') {
        return 'Email sent';
      }
      if (status === 'opened') {
        return 'Email opened but not answered';
      }
      if (status === 'failed') {
        return 'Email failed, please check contact info';
      }
      return 'Wait for sent';
    },
    emailStatusIcon (status) {
      if (status === 'response') {
        return 'drafts';
      } 
      if (status === 'delivered') {
        return 'email';
      }
      if (status === 'opened') {
        return 'drafts';
      } 
      if (status === 'failed') {
        return 'unsubscribe';
      }
      return 'mail_outline';      
    },
    statusColor (status) {
      if (status === 'response') {
        return 'green';
      }
      if (status === 'delivered' || status === 'opened') {
        return 'grey';
      }
      if (status === 'failed') {
        return 'red';
      }
      return 'grey';
    }
  } 
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/client/contacts/components/ContactsRoundTable.vue